import { AbstractControl } from '@angular/forms';

export class ErrorField {
  public validatorName: string;
  public validatorValue: string;
  public fieldName: string;
  public focusableField: string;
  public control: AbstractControl;
}
